/* QILATES — Vitamin Qi section: scroll progress drives the orb + text steps,
   a light particle field drifts inward ("Qi gathering"). Idle when off-screen,
   skipped entirely under prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function setup(root) {
    if (root.dataset.vqReady) return;
    root.dataset.vqReady = '1';

    var steps = root.querySelectorAll('[data-vq-step]');
    var dots = root.querySelectorAll('.vq-dots span');
    var canvas = root.querySelector('canvas');
    var ctx = canvas && canvas.getContext('2d');
    var glow = getComputedStyle(root).getPropertyValue('--vq-glow').trim() || '#C9CF9A';
    var visible = false, current = -1, particles = [], w = 0, h = 0, dpr = 1;

    var stage = root.querySelector('.vq-stage');
    function clamp01(v) { return Math.min(Math.max(v, 0), 1); }

    function update() {
      // The next section overlaps the last pinned screen (negative margin = stage height).
      // --vq-p: the text steps, done by the time the next section starts to enter.
      // --vq-x: the exit — orb expands and fades while the next section slides up over it,
      //         starting a little before it enters and ending once it covers the screen.
      var r = root.getBoundingClientRect();
      var s = stage.offsetHeight, scrolled = -r.top;
      var enter = r.height - 2 * s;
      var p = enter > 0 ? clamp01(scrolled / enter) : 0;
      var x = clamp01((scrolled - (enter - 0.4 * s)) / (1.4 * s));
      root.style.setProperty('--vq-p', p.toFixed(4));
      root.style.setProperty('--vq-x', x.toFixed(4));
      var i = p < 0.27 ? 0 : p < 0.54 ? 1 : 2;
      if (i !== current) {
        current = i;
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
    }

    function resize() {
      if (!canvas) return;
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var count = w < 750 ? 40 : 80;
      particles = [];
      for (var n = 0; n < count; n++) particles.push(spawn(true));
    }

    function spawn(anywhere) {
      var a = Math.random() * Math.PI * 2;
      var maxR = Math.hypot(w, h) * 0.6;
      return {
        a: a,
        r: anywhere ? maxR * (0.3 + Math.random() * 0.7) : maxR,
        s: 0.25 + Math.random() * 0.6,
        size: 0.6 + Math.random() * 1.6,
        spin: (Math.random() < 0.5 ? -1 : 1) * (0.0006 + Math.random() * 0.0012)
      };
    }

    function draw() {
      if (!visible) return;
      ctx.clearRect(0, 0, w, h);
      var cx = w / 2, cy = h * 0.46, inner = Math.min(h * 0.32, w * 0.41) * 0.85;
      ctx.fillStyle = glow;
      particles.forEach(function (pt, k) {
        pt.r -= pt.s; pt.a += pt.spin;
        if (pt.r < inner) particles[k] = pt = spawn(false);
        var x = cx + Math.cos(pt.a) * pt.r, y = cy + Math.sin(pt.a) * pt.r;
        var fade = Math.min((pt.r - inner) / 160, 1) * 0.75;
        ctx.globalAlpha = Math.max(fade, 0);
        ctx.beginPath(); ctx.arc(x, y, pt.size, 0, Math.PI * 2); ctx.fill();
      });
      requestAnimationFrame(draw);
    }

    var io = new IntersectionObserver(function (es) {
      var was = visible;
      visible = es[0].isIntersecting;
      if (visible && !was && ctx) requestAnimationFrame(draw);
    });
    io.observe(root);

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', function () { resize(); update(); });

    if (ctx) resize();
    update();
  }

  function init() { document.querySelectorAll('[data-vitamin-qi]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
